// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__384xx","content":"LayoutSettings_content__v1Hvd"};